<template>
	<div
		class="px-5 py-3 flex rounded-md mt-2"
		:class="{
			'text-white bg-green-500': type === 'success',
			'text-white bg-yellow-500': type === 'warning',
			'text-white bg-red-500': type === 'danger',
			'text-white bg-blue-500': type === 'info',
		}">
		<slot></slot>
	</div>
</template>

<script setup>
	const props = defineProps({
		type: {
			type: String,
			default: 'info',
			validator: (value) => ['success', 'warning', 'danger', 'info'].includes(value),
		},
	});
</script>
